export const d003 = {
  json: {
    name: 'body',
    type: 'body',
    styles: {
      padding: '',
      backgroundColor: 'rgba(255,255,255,1)',
      borderColor: 'rgba(255,255,255,1)',
    },
    childrens: [
      {
        type: 'block',
        active: false,
        editable: true,
        styles: {
          height: '300px',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '16px',
          backgroundImage:
            'url(https://snapshotstore.fra1.digitaloceanspaces.com/pngtree-blue-background-picture-image_919872-95497)',
          width: '100%',
          backgroundSize: 'cover',
        },
        childrens: [
          {
            type: 'heading',
            active: false,
            editable: true,
            innerText: 'Heading',
            styles: {
              fontSize: '32px',
              fontWeight: '700',
              color: 'rgba(0,0,0,1)',
            },
          },
          {
            type: 'paragraph',
            active: false,
            editable: true,
            innerText:
              "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.",
            styles: {
              textAlign: 'center',
              width: '70%',
              color: 'rgba(0,0,0,1)',
            },
          },
        ],
        dropDown: true,
      },
      {
        type: 'block',
        active: false,
        editable: true,
        styles: {
          marginLeft: 'auto',
          marginRight: 'auto',
          marginTop: '64px',
          borderStyle: 'solid',
          borderRadius: '12px',
          borderColor: 'rgba(205,213,247,1)',
          borderWidth: '1px',
          backgroundColor: 'rgba(205,213,247,0.74)',
          padding: '16px',
          marginBottom: '64px',
        },
        childrens: [
          {
            type: 'block',
            active: false,
            editable: true,
            styles: {
              width: '80%',
              marginLeft: 'auto',
              marginRight: 'auto',
              marginTop: '24px',
            },
            childrens: [
              {
                type: 'heading',
                active: false,
                editable: true,
                innerText: 'Registeration',
                styles: {
                  fontSize: '24px',
                  fontWeight: '500',
                  color: 'rgba(0,0,0,1)',
                },
              },
              {
                type: 'paragraph',
                active: false,
                editable: true,
                innerText: 'There are many variations of passages of Lorem Ipsum available,',
                styles: {
                  fontSize: '14px',
                  color: 'rgba(18,18,18,1)',
                },
              },
            ],
            dropDown: true,
          },
          {
            type: 'divider',
            active: false,
            editable: true,
          },
          {
            type: 'form',
            active: false,
            editable: true,
            submitAction: 'createPass',
            childrens: [
              {
                type: 'block',
                active: false,
                editable: true,
                childrens: [
                  {
                    type: 'label',
                    active: false,
                    editable: true,
                    innerText: 'Email',
                    htmlFor: 'email',
                    inputName: '{{ custom_values.from_email }}',
                    styles: {
                      paddingLeft: '10px',
                      paddingRight: '10px',
                    },
                  },
                  {
                    type: 'input',
                    active: true,
                    editable: true,
                    value: 'md0pJUHrOskPO8rWa8ht',
                    inputName: '{{ custom_values.from_email }}',
                    id: 'email',
                    name: 'email',
                    inputType: 'email',
                    placeholder: 'Place your email',
                    required: true,
                    styles: {
                      backgroundColor: 'rgba(142,195,239,0.8)',
                      color: 'rgba(0,0,0,1)',
                      borderRadius: '8px',
                      borderWidth: '1px',
                      borderColor: 'rgba(142,195,239,1)',
                      borderStyle: 'solid',
                      paddingLeft: '16px',
                      paddingRight: '16px',
                      paddingTop: '4px',
                      paddingBottom: '4px',
                    },
                  },
                ],
                dropDown: true,
              },
              {
                type: 'button',
                active: false,
                editable: true,
                elementType: 'submit',
                innerText: 'Submit',
                styles: {
                  marginTop: '28px',
                  width: '128px',
                  borderRadius: '8px',
                  backgroundColor: 'rgba(142,195,239,0.8)',
                  color: 'rgba(0,0,0,1)',
                  fontSize: '16px',
                  paddingTop: '8px',
                  paddingBottom: '9px',
                  borderColor: 'rgba(142,195,239,1)',
                },
                css: '',
              },
            ],
            dropDown: true,
            styles: {
              width: '80%',
              marginLeft: 'auto',
              marginRight: 'auto',
              marginBottom: '24px',
            },
          },
        ],
        css: 'max-width: 600px',
        dropDown: true,
      },
    ],
    dropDown: true,
    active: false,
  },
  html: '<style>\n  @media (max-width: 767px) {\n    .block{\n      flex-wrap: wrap !important;\n    }\n    .block>div{\n      width: 100% !important;\n    }\n  }\n  </style><div class="body false" style="width: 100%; background-repeat: no-repeat; background-color: rgb(255, 255, 255); overflow: auto; border-color: rgb(255, 255, 255);"><div class="block cd false" style="display: flex; flex-direction: column; height: 300px; background-repeat: no-repeat; transition: 0.1s; color: inherit; align-items: center; justify-content: center; padding: 16px; background-image: url(&quot;https://snapshotstore.fra1.digitaloceanspaces.com/pngtree-blue-background-picture-image_919872-95497&quot;); width: 100%; background-size: cover;"><div class="element cd false" contenteditable="false" style="font-size: 32px; font-weight: 700; color: rgb(0, 0, 0);">Heading</div><div class="element cd false" contenteditable="false" style="text-align: center; width: 70%; color: rgb(0, 0, 0);">There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don\'t look even slightly believable.</div></div><div class="block cd false" style="display: flex; flex-direction: column; height: fit-content; background-repeat: no-repeat; transition: 0.1s; color: inherit; margin: 64px auto; border-style: solid; border-radius: 12px; border-color: rgb(205, 213, 247); border-width: 1px; background-color: rgba(205, 213, 247, 0.74); padding: 16px; max-width: 600px;"><div class="block cd false false" style="display: flex; flex-direction: column; height: fit-content; background-repeat: no-repeat; transition: 0.1s; color: inherit; width: 80%; margin-left: auto; margin-right: auto; margin-top: 24px;"><div class="element cd false" contenteditable="false" style="font-size: 24px; font-weight: 500; color: rgb(0, 0, 0);">Registeration</div><div class="element cd false" contenteditable="false" style="font-size: 14px; color: rgb(18, 18, 18);">There are many variations of passages of Lorem Ipsum available,</div></div><div class="element divider cd false" style="width: 80%; height: 1px; background: rgb(202, 202, 202); margin: 25px auto;"></div><form id="createPass" class="element cd false" style="width: 80%; margin-left: auto; margin-right: auto; margin-bottom: 24px;"><div class="block cd false false" style="display: flex; flex-direction: column; height: fit-content; background-repeat: no-repeat; transition: 0.1s; color: inherit;"><label class="element cd false" contenteditable="false" for="{{ custom_values.from_email }}" style="padding-left: 10px; padding-right: 10px;">Email</label><input class="element cd focused" name="{{ custom_values.from_email }}" id="{{ custom_values.from_email }}" placeholder="Place your email" type="email" required="" data-field-id="{{ custom_values.from_email }}" value="md0pJUHrOskPO8rWa8ht" style="background-color: rgba(142, 195, 239, 0.8); color: rgb(0, 0, 0); border-radius: 8px; border-width: 1px; border-color: rgb(142, 195, 239); border-style: solid; padding: 4px 16px;"></div><button class="element cd false" contenteditable="false" type="submit" style="margin-top: 28px; width: 128px; border-radius: 8px; background-color: rgba(142, 195, 239, 0.8); color: rgb(0, 0, 0); font-size: 16px; padding-top: 8px; padding-bottom: 9px; border-color: rgb(142, 195, 239); display: block;">Submit</button></form></div></div>',
}
